import React from 'react';
import moment from 'moment';
import CantSkipProcessingDelivery from 'components/infoBoxes/CantSkipProcessingDelivery';
import CantSkipDispatchedDelivery from 'components/infoBoxes/CantSkipDispatchedDelivery';
import CantSkipFirstDelivery from 'components/infoBoxes/CantSkipFirstDelivery';
import CantSkipLastPack from 'components/infoBoxes/CantSkipLastPack';
import CantSkipLimitReached from 'components/infoBoxes/CantSkipLimitReached';
import orderPath from 'containers/paths/OrdersContainerPath';

import TextLink from 'components/TextLink';

export const reduceToUniqueProducts = (items) => Object.values(
  items.reduce((accumulator, next) => {
    accumulator[next.url] = next;
    return accumulator;
  }, {}),
);

export const renderPackActions = (pack) => {
  const canBeSkipped = pack.availableActions.includes('Holiday Pack');
  if (canBeSkipped) {
    return (
      <TextLink
        props={{ to: orderPath(pack.id, 'skip') }}
        dataLayer={{ action: 'Skip a Pack', label: 'Skip a Pack - Start' }}
        rightChevron
      >
        Skip this delivery
      </TextLink>
    );
  }

  if (pack.status === 'Processing') {
    return <CantSkipProcessingDelivery />;
  }

  if (pack.status === 'Dispatched' && moment(pack.deliveryDate).isAfter()) {
    return <CantSkipDispatchedDelivery />;
  }

  if (!pack.previousPack) {
    return <CantSkipFirstDelivery />;
  }

  if (!pack.nextPack && pack.payments.find((p) => p.status === 'Completed')) {
    return <CantSkipLastPack storeUrl={pack.storeUrl} />;
  }

  if (pack.status === 'Pending') {
    return <CantSkipLimitReached storeUrl={pack.storeUrl} />;
  }
  return null;
};
